module.exports = __webpack_public_path__ + "static/img/HList4.c93a8b9c.png";